import React, { useState, useEffect, useMemo } from 'react';
import { Button, message, Result } from 'antd';
import { Select } from 'antd';
import { Card } from 'antd';
import { Alert, Spin } from 'antd';
import { CreditCardOutlined, BankOutlined, CheckCircleOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { Divider } from 'antd';
import { Radio } from 'antd';
import { Typography } from 'antd';
import { Row, Col } from 'antd';
import { Helmet } from 'react-helmet';

import { request } from 'src/helpers/request';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
// import { request } from 'axios';
import "./style.css"
import { formatRupiah, isDevelopment } from 'src/module/helpers';
import PaymentCheckout from './PaymentCheckout';
import HalamanLunas from './HalamanLunas';

const { Text, } = Typography;

const PaymentPage = () => {

    const [paymentMethod, setPaymentMethod] = useState('');
    const [paymentSelected, setSelectedPayment] = useState(null);
    const [transactionStatus, setTransactionStatus] = useState('idle');

    const params = useParams()
    const [isLoading, setLoading] = useState(false)

    const [data, setDataContent] = useState({

    })
    const [isError, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null)


    const [isLoadingPanel, setLoadingPanel] = useState(false)
    const [isErrorPanel, setErrorPanel] = useState(false)
    const [dataPanel, setDataPanel] = useState(null)


    const getDataInvoice = async (id_invoice, refresh) => {
        setLoading(true);
        setError(false);
        setErrorMessage(null);

        const maxRetries = 3;
        let attempt = 0;

        while (attempt < maxRetries) {
            try {
                const urlQuery = new URLSearchParams({
                    id_invoice,
                    ...(refresh && {
                        refresh
                    })
                })
                const response = await request('get', '/get_invoice?' + urlQuery.toString());
                const content = response?.data
                setDataContent(content);

                if (content?.default_payment_method) {
                    setPaymentMethod(content?.default_payment_method)
                }

                setLoading(false);
                break; // berhasil, keluar dari loop
            } catch (error) {

                attempt++;
                const message = error?.response?.data?.message || error?.message;
                const statusCode = error?.response?.status;

                if (
                    statusCode === 400 ||
                    message?.toLowerCase().includes('Invoice tidak tersedia') ||
                    message?.toLowerCase().includes('not found')
                ) {
                    setError(true);
                    setErrorMessage(message || 'Invoice tidak tersedia');
                    setLoading(false);
                    break; // hentikan loop tanpa retry
                }


                if (attempt >= maxRetries) {
                    setError(true);
                    setErrorMessage(error?.message);
                } else {
                    await new Promise(resolve => setTimeout(resolve, 1000 * attempt)); // retry dengan jeda
                }
            } finally {
                if (attempt >= maxRetries || !setError) {
                    setLoading(false);
                }

            }
        }
    };


    useEffect(() => {
        if (params?.id_invoice) {
            (async () => {
                await getDataInvoice(params.id_invoice);
            })();
        }
    }, [params?.id_invoice]);

    useEffect(() => {
        console.log(data)
        if (data?.bank?.availBank?.status === "EXPIRED") {
            setTimeout(() => {
                (async () => {
                    await getDataInvoice(params.id_invoice, true);
                })();
            }, 500);
        }
    }, [data?.bank?.status])


    const handlePaymentMethodChange = (value) => {
        setPaymentMethod(value);
        setErrorMessage('');
    };


    const processPayment = async (channel) => {
        // alert(JSON.stringify(channel))

        if (!channel) {
            message.error("Anda belum memilih methode pembayaran")
            return
        }

        setLoadingPanel(true)
        setErrorPanel(null)

        try {
            /* preloading panel */
            const res = await request("post", "/make-invoice", {
                id_invoice: params?.id_invoice,
                channel
            })
            // setDataPanel(res?.data)
            message.info("Url pembayaran berhasil dibuat")
            setDataContent(res?.data);
            // setLoading(false);

        } catch (error) {
            message.error("Pembuatan link pembayaran gagal ")
            setErrorPanel(error)
        } finally {
            setLoadingPanel(false)
        }
    }

    const handleSelectedBank = (event) => {
        setSelectedPayment(event?.target?.value)
    }

    const renderPaymentDetails = () => {
        const bankAvail = data?.bankAvail
        switch (paymentMethod) {
            case 'retail_outlet':
                return (
                    <div className="space-y-4">
                        <div className="space-y-2">
                            <Radio.Group
                                onChange={handleSelectedBank}
                                value={paymentSelected}
                            >
                                {bankAvail?.retail_outlet?.map((bank) => (
                                    <Radio
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            padding: '8px 4px',
                                        }}
                                        value={bank.bankCode}
                                        key={bank.bankCode}
                                    >
                                        <div className='checkout-bank-transfer-item__card'>
                                            <div className='checkout-bank-transfer-item__icon-container'>
                                                <img
                                                    src={bank.logo}
                                                    alt={bank.bankCode}
                                                    className='checkout-bank-transfer-item__icon'
                                                />
                                            </div>
                                            <div className='checkout-bank-transfer-item__main'>
                                                <div className='checkout-bank-transfer-item__title'>{bank.bankCode} / Admin {formatRupiah(bank?.adminFee, true)})</div>
                                            </div>

                                        </div>
                                    </Radio>
                                ))}
                            </Radio.Group>

                        </div>
                    </div>
                );

            case 'bank_transfer':
                return (
                    <div className="space-y-4">
                        <div className="space-y-2">
                            <Radio.Group
                                onChange={handleSelectedBank}
                                value={paymentSelected}
                            >
                                {bankAvail?.bank_transfer?.map((bank) => (
                                    <Radio
                                        style={{

                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            padding: '8px 4px',
                                        }}
                                        value={bank.bankCode}
                                        key={bank.bankCode}
                                    >
                                        <div className='checkout-bank-transfer-item__card'>
                                            <div className='checkout-bank-transfer-item__icon-container'>
                                                <img
                                                    src={bank.logo}
                                                    alt={bank.bankCode}
                                                    className='checkout-bank-transfer-item__icon'

                                                />
                                            </div>
                                            <div className='checkout-bank-transfer-item__main'>
                                                <div className='checkout-bank-transfer-item__title'>{bank.bankCode} / Admin {formatRupiah(bank?.adminFee, true)}</div>
                                            </div>

                                        </div>
                                    </Radio>
                                ))}
                            </Radio.Group>

                        </div>
                    </div>
                );
            case 'e_wallet':
                return (
                    <div className="space-y-4">
                        <div className="space-y-2">
                            <Radio.Group
                                onChange={handleSelectedBank}
                                value={paymentMethod}
                            >
                                {bankAvail?.e_wallet?.map((bank) => (
                                    <Radio
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            padding: '8px 4px',
                                        }}
                                        value={bank.bankCode}
                                        key={bank.bankCode}
                                    >
                                        <div className='checkout-bank-transfer-item__card'>
                                            <div className='checkout-bank-transfer-item__icon-container'>
                                                <img
                                                    src={bank.logo}
                                                    alt={bank.bankCode}
                                                    className='checkout-bank-transfer-item__icon'

                                                />
                                            </div>
                                            <div className='checkout-bank-transfer-item__main'>
                                                <div className='checkout-bank-transfer-item__title'>{bank.bankCode} / Admin {formatRupiah(bank?.adminFee, true)}</div>
                                            </div>

                                        </div>
                                    </Radio>
                                ))}
                            </Radio.Group>

                        </div>
                    </div>
                );
            case 'qris':
                return (
                    <div className="space-y-4">
                        <div className="space-y-2">
                            <Radio.Group
                                onChange={handleSelectedBank}
                                value={paymentMethod}
                            >
                                {bankAvail?.qris?.map((bank) => (
                                    <Radio
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            padding: '8px 4px',
                                        }}
                                        value={bank.bankCode}
                                        key={bank.bankCode}
                                    >
                                        <div className='checkout-bank-transfer-item__card'>
                                            <div className='checkout-bank-transfer-item__icon-container'>
                                                <img
                                                    src={bank.logo}
                                                    alt={bank.bankCode}
                                                    className='checkout-bank-transfer-item__icon'

                                                />
                                            </div>
                                            <div className='checkout-bank-transfer-item__main'>
                                                <div className='checkout-bank-transfer-item__title'>{bank.bankCode} / Admin {formatRupiah(bank?.adminFee, true)}</div>
                                            </div>

                                        </div>
                                    </Radio>
                                ))}
                            </Radio.Group>

                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    const getPaymentMethodIcon = () => {
        switch (paymentMethod) {
            case 'retail_outlet':
                return <CreditCardOutlined className="mr-2" />;
            case 'bank_transfer':
                return <BankOutlined className="mr-2" />;
            case 'e_wallet':
                return <CheckCircleOutlined className="mr-2" />;
            case 'qris':
                return <CheckCircleOutlined className="mr-2" />;
            default:
                return null;
        }
    };

    const renderPaymentSelected = (onlyAdminBank) => {

        const paymentArray = data?.bankAvail?.[paymentMethod] ?? null;

        if (paymentArray) {
            const bank = paymentArray?.find(item => item?.bankCode === paymentSelected)

            if (onlyAdminBank) return bank

            return <div className='checkout-bank-transfer-item__card'>
                <div className='checkout-bank-transfer-item__icon-container'>
                    <img
                        src={bank?.logo}
                        alt={bank?.bankCode}
                        className='checkout-bank-transfer-item__icon'
                    />
                </div>
                <div className='checkout-bank-transfer-item__main'>
                    <div className='checkout-bank-transfer-item__title'>{bank?.bankCode} / Admin {formatRupiah(bank?.adminFee, true)}</div>
                </div>

            </div>
        }


        return (
            <div> ✅ Metode dipilih: <strong>{paymentSelected}</strong></div>
        )
    }


    if (isLoading) return (
        <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-start py-12 px-4 sm:px-6 lg:px-8">
            <Spin spinning={true} size='large' tip="Silahkan tunggu.." />
        </div>
    )



    // console.log(data)
    const detailInvoice = data?.detailInvoice

    if (isDevelopment)
        console.log(data)

    const bank = renderPaymentSelected(true)
    const totalPembayaran = detailInvoice?.total_tagihan + bank?.adminTaxFee + bank?.adminFee


    const renderDokument = () => {
        // logika di sini
        // misalnya:

        if (data?.status === "ordered") {
            return <PaymentCheckout detailInvoice={data} />
        }

        if (data?.status?.toLowerCase() === "lunas") {
            return (
                <HalamanLunas detailInvoice={detailInvoice} />
            )
        }

        if (isError) {
            return (
                <Result
                    status="404"
                    title={errorMessage || "Invoice Tidak Ditemukan"}
                    subTitle="Maaf, invoice yang Anda cari tidak tersedia atau sudah dihapus."
                    extra={
                        <Button
                            type="primary"
                            onClick={() => (window.location.href = "https://ihore.id")}
                        >
                            Kembali ke Beranda
                        </Button>
                    }
                />
            )
        }



        return (
            <Spin spinning={isLoadingPanel}>
                <Card className="w-full max-w-2xl shadow-lg">
                    <div className="text-center">
                        <h2 className="text-2xl font-semibold text-gray-900">Pembayaran</h2>
                        <p className="text-gray-500">
                            Selesaikan pembayaran Anda untuk Tagihan internet Bulan {detailInvoice?.bulan_tagihan} tahun {detailInvoice?.tahun_tagihan}
                        </p>
                    </div>
                    <div className="space-y-6 p-6">
                        {isLoading ? (
                            <div className="text-center">
                                <Spin size="large" />
                                <p className="mt-2 text-gray-500">Memuat informasi pelanggan...</p>
                            </div>
                        ) : (
                            <div className="space-y-6">
                                {/* Informasi Pelanggan */}
                                <div className="text-lg font-semibold mb-2">
                                    Informasi Pelanggan
                                </div>
                                <div className='p-4 pt-0'>
                                    <Row align="middle" gutter={[16, 16]}>
                                        <Col span={24}>
                                            <div className="text-sm text-gray-700">
                                                🆔 <strong>{detailInvoice?.id_pelanggan}</strong> | 🏫 <strong>{detailInvoice?.nama_lengkap}</strong>
                                            </div>
                                        </Col>
                                        <Col span={24}>
                                            <div className="text-sm text-gray-700">
                                                📍 {detailInvoice?.alamat}
                                            </div>
                                        </Col>
                                    </Row>
                                </div>



                                {/* Produk yang dipesan */}
                                <div>
                                    <div className="text-lg font-semibold text-gray-900 mb-2">Informasi Tagihan:</div>
                                    <div className="border rounded-md p-4 bg-white shadow-sm">
                                        <Row gutter={[0, 12]}>
                                            {/* Periode Tagihan */}
                                            <Col span={24}>
                                                <Text className="text-gray-800 text-base">
                                                    📅 Tagihan Internet bulan <strong>{detailInvoice?.bulan_tagihan}</strong> tahun <strong>{detailInvoice?.tahun_tagihan}</strong>
                                                </Text>
                                            </Col>

                                            {/* Harga */}
                                            <Col span={24}>
                                                <Text className="text-gray-800 text-base">
                                                    💰 Harga: <strong>
                                                        {formatRupiah(detailInvoice?.total_tagihan, true)}
                                                    </strong>
                                                </Text>
                                            </Col>

                                            {/* Divider dan Subtotal */}
                                            <Col span={24}>
                                                <Divider style={{ margin: '16px 0' }} className="border-gray-200" />
                                                <div className="flex justify-end">
                                                    <Text className="text-base font-bold text-gray-900">
                                                        🧾 Subtotal: {formatRupiah(detailInvoice?.total_tagihan, true)}
                                                    </Text>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>

                                <label htmlFor="paymentMethod" className="block text-sm font-bold text-gray-700 mb-2">
                                    💳 Metode Pembayaran
                                </label>

                                {isLoading ? (
                                    <div className="text-center">
                                        <Spin size="large" />
                                        <p className="mt-2 text-gray-500">Memuat informasi metode pembayaran...</p>
                                    </div>
                                ) : (
                                    <React.Fragment>
                                        {!paymentSelected ? (
                                            <Select
                                                onSelect={handlePaymentMethodChange}
                                                value={paymentMethod}
                                                style={{ width: '100%' }}
                                                disabled={transactionStatus === 'processing'}
                                            >
                                                {data?.bankAvail?.bank_transfer?.length > 0 && (
                                                    <Select.Option value="bank_transfer">
                                                        <div className="flex items-center py-2">
                                                            <BankOutlined className="mr-2" />
                                                            <span className="text-gray-700">Transfer Bank</span>
                                                        </div>
                                                    </Select.Option>
                                                )}


                                                <Select.Option value="retail_outlet">
                                                    <div className="flex items-center py-2">
                                                        <CreditCardOutlined className="mr-2" />
                                                        <span className="text-gray-700">Retail Outlet</span>
                                                    </div>
                                                </Select.Option>
                                                <Select.Option value="e_wallet">
                                                    <div className="flex items-center py-2">
                                                        <CheckCircleOutlined className="mr-2" />
                                                        <span className="text-gray-700">E-Wallet</span>
                                                    </div>
                                                </Select.Option>
                                                <Select.Option value="qris">
                                                    <div className="flex items-center py-2">
                                                        <CheckCircleOutlined className="mr-2" />
                                                        <span className="text-gray-700">QRIS</span>
                                                    </div>
                                                </Select.Option>
                                            </Select>
                                        ) : (
                                            <div className="bg-gray-50 border border-gray-300 rounded p-3 flex justify-between items-center">
                                                <span className="text-gray-800">
                                                    {renderPaymentSelected()}
                                                </span>
                                                <button
                                                    onClick={() => {
                                                        setSelectedPayment(null);
                                                        setPaymentMethod("bank_transfer");
                                                    }}
                                                    className="text-blue-500 hover:underline text-sm"
                                                >
                                                    Ubah
                                                </button>
                                            </div>
                                        )}
                                    </React.Fragment>
                                )}



                                {!paymentSelected && renderPaymentDetails()}

                                {errorMessage && (
                                    <Alert
                                        message="Error"
                                        description={errorMessage}
                                        type="error"
                                        showIcon
                                        className="mt-4"
                                    />
                                )}


                            </div>
                        )}

                        {/* Rincian Pembayaran */}
                        <div>

                            <label htmlFor="paymentMethod" className="block text-sm font-bold text-gray-700">
                                <ShoppingCartOutlined className="mr-2" /> Rincian Pembayaran
                            </label>
                            <Divider className="border-gray-200" />
                            <div className="pt-2 space-y-2">
                                <div className="flex justify-between items-center">
                                    <span className="text-gray-700">Subtotal Produk:</span>
                                    <span className="font-medium text-gray-900">
                                        {detailInvoice?.total_tagihan?.toLocaleString('id-ID', {
                                            style: 'currency',
                                            currency: 'IDR',
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0,
                                        })}
                                    </span>
                                </div>
                                <div className="flex justify-between items-center">
                                    <span className="text-gray-700">Admin Bank {bank?.bankCode}: </span>
                                    <span className="font-bold text-gray-900">
                                        {formatRupiah(bank?.adminFee, true)}
                                    </span>
                                </div>
                                <div className="flex justify-between items-center">
                                    <span className="text-gray-700">Pajak {bank?.bankCode}: </span>
                                    <span className="font-bold text-gray-900">
                                        {formatRupiah(bank?.adminTaxFee, true)}
                                    </span>
                                </div>
                                <div className="flex justify-between items-center mt-2 font-semibold text-xl">
                                    <span className="text-gray-900">Total Pembayaran:</span>
                                    <span className="text-blue-600">
                                        {formatRupiah(totalPembayaran, true)}
                                    </span>
                                </div>
                                <Button
                                    onClick={() => processPayment(bank)}
                                    className="w-full bg-blue-600 hover:bg-blue-700 font-semibold py-2 px-4 rounded-md transition duration-300 ease-in-out shadow-md"
                                    disabled={transactionStatus === 'processing'}
                                >
                                    {transactionStatus === 'processing' ? (
                                        <>
                                            <Spin indicator={{ size: 24 }} className="mr-2" />
                                            Memproses...
                                        </>
                                    ) : (
                                        <>
                                            {getPaymentMethodIcon()}
                                            Bayar Sekarang
                                        </>
                                    )}
                                </Button>

                                {transactionStatus === 'success' && (
                                    <Alert
                                        message="Pembayaran Berhasil!"
                                        description="Terima kasih atas pembayaran Anda."
                                        type="success"
                                        showIcon
                                        className="mt-4"
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </Card>
            </Spin>

        );
    };




    return (
        <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-start py-12 px-4 sm:px-6 lg:px-8">
            <Helmet>
                <title>Halaman Pembayaran - {detailInvoice?.nama_lengkap || "Admin"}</title>
                <meta name="description" content="Selesaikan pembayaran Anda dengan mudah dan aman." />
                <meta name="keywords" content="pembayaran, online, e-commerce, transaksi" />
                {/* Tailwind CSS */}
                <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet" />
                <style>
                    {`
                      body {
                        font-family: 'Inter', sans-serif;
                      }
                    `}
                </style>
                <script src="https://cdn.jsdelivr.net/npm/@tailwindcss/browser@4"></script>
            </Helmet>

            <div className="w-full flex justify-center py-6">
                <div className="flex items-center space-x-6">
                    <img
                        src="/images/logo-glowing.png"
                        alt="Logo"
                        className="w-24 h-24 object-contain"
                    />
                    <div>
                        <h1 className="text-xl font-semibold text-gray-900">
                            PT SARANA KAWAN SETIA
                        </h1>
                        <p className="text-gray-600 text-sm mt-1 leading-relaxed">
                            📍 Jalan Rejasa Kenteng KM 2 RT 004 RW 003<br />
                            Rejasa, Madukara Kab. Banjarnegara, Jawa Tengah
                        </p>
                    </div>
                </div>
            </div>

            {renderDokument()}

        </div>
    );
};

export default PaymentPage;
